/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.links-menu-extension.alignment.title': 'Zarovnání',
  'company-hub.links-menu-extension.all.borders.label-text': 'Všechny strany',
  'company-hub.links-menu-extension.background.color': 'Barva pozadí',
  'company-hub.links-menu-extension.background.title': 'Pozadí',
  'company-hub.links-menu-extension.border.color': 'Barva okraje',
  'company-hub.links-menu-extension.border.position': 'Poloha okraje',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Dolní ohraničení',
  'company-hub.links-menu-extension.center.option': 'Na střed',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Přidat důležité odkazy',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Připojit',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Seskupení související odkazy',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Dosáhli jste maximálního počtu vnořených úrovní.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Nabídka',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Zrušit',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Odstranit',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Tato akce odstraní tuto položku a všechny vnořené položky.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Odstranit položku',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Přidat dílčí položku',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Odstranit položku',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Upravit vlastnosti',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Posunout dolů',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Posunout nahoru',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Otevřít odkaz',
  'company-hub.links-menu-extension.config-panel.items.label': 'Položky',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'Dosáhli jste maximálního počtu položek, které jde přidat do nabídky odkazů.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Nová položka',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Přidejte odkazy a uspořádejte je pomocí podnabídek. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Další informace o nabídce odkazů',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Přidejte odkazy a uspořádejte je pomocí podnabídek.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Zrušit',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Potvrdit',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Vyplňte toto pole.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Zobrazte text.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Název položky',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Potvrdit',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Více',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Styly',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'Dosáhli jste maximálního počtu položek, které jde přidat do nabídky odkazů.',
  'company-hub.links-menu-extension.config-panel.title': 'Nabídka odkazů',
  'company-hub.links-menu-extension.fixed.option': 'Uchyceno nahoře',
  'company-hub.links-menu-extension.left.option': 'Vlevo',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Více',
  'company-hub.links-menu-extension.manifest.extension-description':
    'Přidejte řadu odkazů a podnabídek do centra společnosti.',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Nabídka odkazů',
  'company-hub.links-menu-extension.manifest.extension-title': 'Nabídka odkazů [nové]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'O nás',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Tým 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Výhody',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Týmy',
  'company-hub.links-menu-extension.no.border.label-text': 'Žádný',
  'company-hub.links-menu-extension.right.option': 'Vpravo',
  'company-hub.links-menu-extension.section.collapse.label': 'Sbalit sekci',
  'company-hub.links-menu-extension.section.expand.label': 'Rozbalit sekci',
  'company-hub.links-menu-extension.selected.state.color': 'Barva vybraného stavu',
  'company-hub.links-menu-extension.text.color': 'Barva textu',
  'company-hub.links-menu-extension.text.title': 'Text',
};
